import { makeStyles } from 'tss-react/mui'
import { Theme } from '@mui/material'

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    padding: theme.spacing(3, 4),
    border: `1px solid ${theme.palette.dividerV2.main}`,
    width: '100%',
    borderRadius: theme.spacing(0.5),
    boxSizing: 'border-box',
  },
  input: {
    width: '50%',
  },
  disableDate: {
    pointerEvents: 'none',
  },
  elementsGap: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2.5),
  },
  sectionText: {
    fontSize: '14px !important',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px !important',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    textAlign: 'left',
    width: '50%',
  },
  resourceRow: {
    display: 'flex',
    gap: theme.spacing(4),
    width: '100%',
  },
  resourcesContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    gap: theme.spacing(3),
    width: '100%',
  },
  trashIcon: {
    color: theme.palette.labraIcon.main,
    cursor: 'pointer',
    paddingTop: theme.spacing(1.5),
    width: '2%',
  },
  buttonSubText: {
    color: theme.palette.textField.main,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
  },
  widthButton: {
    width: 'fit-content',
    marginBottom: theme.spacing(1),
  },
  border: {
    borderBottom: `1px solid ${theme.palette.dividerV2.main}`,
    width: '100%',
    borderRadius: theme.spacing(0.5),
    boxSizing: 'border-box',
  },
  belowBorder: {
    borderBottom: `1px solid ${theme.palette.dividerV2.main}`,
    width: '100%',
    borderRadius: theme.spacing(0.5),
    boxSizing: 'border-box',
    marginBottom: theme.spacing(2.5),
  },
  titleWraper: {
    display: 'flex',
    gap: theme.spacing(4),
  },
  sectionHeading: {
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '24px',
    color: theme.palette.labraText.primary,
  },
  installmentsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    width: '100%',
  },
  price: {
    display: 'flex',
    alignItems: 'baseline',
    fontSize: '16px',
    lineHeight: '24px',
    marginTop: theme.spacing(-1),
  },
  radioSelection: {
    width: 'fit-content',
    marginBottom: theme.spacing(1),
  },
  subSectionContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  metricsRow: {
    display: 'flex',
    gap: theme.spacing(6),
    flexWrap: 'wrap',
    marginTop: theme.spacing(0.5),
  },
  metricItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  totalText: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24px',
    letterSpacing: '0.15px',
    color: theme.palette.textField.dark,
  },
  deleteSpacer: {
    width: '2%',
  },
  trashIconGlyph: {
    width: '14px',
    height: '20px',
  },
}))
